interface EventDetailSectionProps {
    detail: string | null
}

export const EventDetailSection = ({ detail }: EventDetailSectionProps) => {
    if (!detail) return null

    return (
        <>
            <div className="flex gap-3 w-full items-center">
                <p className="text-base leading-[24.8px] font-black text-[#242F3E] opacity-70 whitespace-nowrap">Detail</p>
                <div className="border-b-[1px] border-[#CCCCCC] w-full"></div>
            </div>
            <div className="w-full">
                <div
                    className="text-base leading-[24.8px] text-[#333]"
                    dangerouslySetInnerHTML={{ __html: detail }}
                />
            </div>
        </>
    )
}

